import { useTranslation } from "@pancakeswap/localization";
import { AddIcon, Button, NextLinkFromReactRouter } from "@pancakeswap/uikit";

export function GotoAddLiquidityButton() {
  const { t } = useTranslation();

  return (
    <NextLinkFromReactRouter to="/add">
      <Button id="join-pool-button" width="100%" startIcon={<AddIcon color="invertedContrast" />}>
        {t("Add Liquidity")}
      </Button>
    </NextLinkFromReactRouter>
  );
}
